import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("blanching-cooking")
export class BlanchingCooking {

    @PrimaryGeneratedColumn("increment", { name: 'cooking_id' })
    cookingId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'log_id'
    })
    logId: number;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'time'
    })
    time: Date;

   
     @Column("varchar", {
        nullable: false,
        length: 30,
        name: "blanching_cooking"
    })
    blanchingCooking: string;

    
    @Column({
        type: 'int',
        nullable: false,
        name: 'temp_1'
    })
    temp1: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'temp_2'
    })
    temp2: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'temp_3'
    })
    temp3: number;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'cooking_time'
    })
    cookingTime: Date;

    @Column({
        type: 'int',
        nullable: false,
        name: 'product_core_temp'
    })
    productCoreTemp: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'product_temp_after_chilling'
    })
    productTempAfterChilling: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "steam_pressure"
    })
    steamPressure: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'chill_water_temp'
    })
    chillWaterTemp: number;

    @Column({
        type: 'datetime',
        nullable: false,
        name: 'chiller_time'
    })
    chillerTime: Date;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "remarks"
    })
    remarks: string;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "corrective_action"
    })
    correctiveAction: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

  
}